import React from "react";
import { Dimensions, Image, StyleSheet, Text, View } from "react-native";
import {
  BottomDrawer,
  Button,
  COLORS,
  COMMON_STYLES,
  SIZE,
  SUBHEADING_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import CameraIcon from "../../assests/icons/CameraIcon";
import ImgStatusText from "../ImgStatusText";
import { useTranslation } from "react-i18next";

const { width } = Dimensions.get("window");

type ImgDetectModalProps = {
  onClose: () => void;
  showModal: boolean;
  imgSource: any;
  title: string;
  description: string;
  actualImg?: any;
  distortedImg?: any;
  actualImgText?: string;
  distortedImgText?: string;
};

const ImgDetectModal = ({
  onClose,
  showModal,
  imgSource,
  title,
  description,
  actualImg,
  distortedImg,
  actualImgText,
  distortedImgText,
}: ImgDetectModalProps) => {
  const { t } = useTranslation();

  return (
    <BottomDrawer
      onClose={onClose}
      visible={showModal}
      modalStyle={[COMMON_STYLES.ph1]}
    >
      <Image
        source={imgSource}
        style={[
          COMMON_STYLES.mb1,
          COMMON_STYLES["mb0.5"],
          {
            width: 174,
            height: 174,
          },
          COMMON_STYLES.alignSelfCenter,
        ]}
        // resizeMode="contain"
      />
      <Text
        style={[
          COMMON_STYLES.textCenter,
          TYPOGRAPHY.HEADING3,
          VARIANTS_STYLES.SEMI_EMPHASIZED,
          COMMON_STYLES.mt1,
          COMMON_STYLES.mb1,
        ]}
      >
        {t(title)}
      </Text>
      <Text
        style={[
          COMMON_STYLES.textCenter,
          TEXT_STYLES.textNeutral90,
          COMMON_STYLES.mb1,
          COMMON_STYLES.ph1,
          TYPOGRAPHY.TEXT2,
        ]}
      >
        {t(description)}
      </Text>

      <Button
        buttonStyle={[COMMON_STYLES.fullWidth]}
        textStyle={[SUBHEADING_STYLES.MEDIUM_S2, TEXT_STYLES.textWhite]}
        text="Take a new photo"
        onClick={onClose}
        iconLeft={<CameraIcon />}
        size={SIZE.large}
      />
      {distortedImgText && actualImgText && (
        <>
          <Text
            style={[
              TEXT_STYLES.textNeutral90,
              COMMON_STYLES.mv1,
              VARIANTS_STYLES.SEMI_EMPHASIZED,
              TYPOGRAPHY.TEXT1,
              { alignSelf: "flex-start" },
            ]}
          >
            How to take better photos?
          </Text>
          <View
            style={[
              COMMON_STYLES.row,
              COMMON_STYLES.fullWidth,
              { justifyContent: "space-around" },
            ]}
          >
            <ImgStatusText
              source={distortedImg}
              blurStatus={distortedImgText}
            />
            <ImgStatusText source={actualImg} blurStatus={actualImgText} />
          </View>
        </>
      )}
    </BottomDrawer>
  );
};

export default ImgDetectModal;
